var $ad2bcec7a0192558$exports = {};
const $ad2bcec7a0192558$var$mm = 10 // pixels per millimeter
;
let $ad2bcec7a0192558$var$dimensions = 68.8;
const $ad2bcec7a0192558$var$device = document.body.querySelector(".device");
const $ad2bcec7a0192558$var$canvas = document.createElement("canvas");
const $ad2bcec7a0192558$var$ctx = $ad2bcec7a0192558$var$canvas.getContext("2d");
$ad2bcec7a0192558$var$device.style.width = $ad2bcec7a0192558$var$dimensions * 1.25 + 16 + "mm";
$ad2bcec7a0192558$var$device.style.height = $ad2bcec7a0192558$var$dimensions * 1.25 + 16 + "mm";
$ad2bcec7a0192558$var$canvas.style.width = $ad2bcec7a0192558$var$dimensions + "mm";
$ad2bcec7a0192558$var$canvas.style.height = $ad2bcec7a0192558$var$dimensions + "mm";
$ad2bcec7a0192558$var$canvas.width = $ad2bcec7a0192558$var$dimensions * $ad2bcec7a0192558$var$mm;
$ad2bcec7a0192558$var$canvas.height = $ad2bcec7a0192558$var$dimensions * $ad2bcec7a0192558$var$mm;
$ad2bcec7a0192558$var$device.append($ad2bcec7a0192558$var$canvas);
$ad2bcec7a0192558$var$canvas.classList.add("speaker");
const $ad2bcec7a0192558$var$p = document.createElement("p");
document.body.append($ad2bcec7a0192558$var$p);
$ad2bcec7a0192558$var$ctx.fillStyle = `#222`;
const $ad2bcec7a0192558$var$form = document.getElementById("form");
if ($ad2bcec7a0192558$var$form) {
    const input = $ad2bcec7a0192558$var$form.querySelector("#dimension");
    $ad2bcec7a0192558$var$form.querySelector("#submit-in")?.addEventListener("click", ()=>{
        const sidein = parseFloat(input.value);
        $ad2bcec7a0192558$var$setDimensions(sidein * 25.4);
    });
    $ad2bcec7a0192558$var$form.querySelector("#submit-cm")?.addEventListener("click", ()=>{
        const sidecm = parseFloat(input.value);
        $ad2bcec7a0192558$var$setDimensions(sidecm * 10);
    });
    $ad2bcec7a0192558$var$form.querySelector("#submit-cm2")?.addEventListener("click", ()=>{
        const surfacecm = parseFloat(input.value);
        $ad2bcec7a0192558$var$setDimensions(Math.sqrt(surfacecm / Math.PI) * 2 * 10);
    });
}
$ad2bcec7a0192558$var$setDimensions($ad2bcec7a0192558$var$dimensions);
function $ad2bcec7a0192558$var$setDimensions(sizeInMm) {
    console.log(sizeInMm + " mm");
    if ($ad2bcec7a0192558$var$form) $ad2bcec7a0192558$var$form.querySelector("#value").textContent = `Membrane emissive surface : ${Math.round(Math.PI * (sizeInMm / 10 / 2) ** 2 * 100) / 100} cm\xb2`;
    $ad2bcec7a0192558$var$dimensions = sizeInMm;
    $ad2bcec7a0192558$var$device.style.width = $ad2bcec7a0192558$var$dimensions * 1.25 + 16 + "mm";
    $ad2bcec7a0192558$var$device.style.height = $ad2bcec7a0192558$var$dimensions * 1.25 + 16 + "mm";
    $ad2bcec7a0192558$var$canvas.style.width = $ad2bcec7a0192558$var$dimensions + "mm";
    $ad2bcec7a0192558$var$canvas.style.height = $ad2bcec7a0192558$var$dimensions + "mm";
    $ad2bcec7a0192558$var$canvas.width = $ad2bcec7a0192558$var$dimensions * $ad2bcec7a0192558$var$mm;
    $ad2bcec7a0192558$var$canvas.height = $ad2bcec7a0192558$var$dimensions * $ad2bcec7a0192558$var$mm;
    $ad2bcec7a0192558$var$generate();
}
function $ad2bcec7a0192558$var$generateHolesInCircle(_rows, _base) {
    $ad2bcec7a0192558$var$ctx.clearRect(0, 0, $ad2bcec7a0192558$var$canvas.width, $ad2bcec7a0192558$var$canvas.height);
    let circles = [
        1
    ];
    const u = _base;
    for(let a = 1; a < _rows; a++)circles.push(a * u);
    // const circles = [1, 6, 12, 20, 24, 32, 36]
    // const circles = [1, 8, 16, 24, 32, 40]
    // const circles = [1, 6, 9, 12, 15, 18]
    // const circles = [1, 6, 10, 15, 24, 33, 40]
    // const circles = [2, 3, 5, 7, 11, 13, 17, 19] // prime numbers
    // let circles = [1]
    // const j = 7
    // for (let a = 0; a < 6; a++) {
    //   circles.push(Math.floor((circles[a] + Math.random() * 10) / j) * j)
    // }
    const holesTotalArea = Math.PI * Math.pow($ad2bcec7a0192558$var$dimensions / 2, 2) * 0.25 // 25% air
    ;
    const numberOfHoles = circles.reduce((acc, val)=>acc + val);
    const holeArea = holesTotalArea / numberOfHoles;
    const holeRadius = Math.round(Math.sqrt(holeArea / Math.PI) * 4) / 4;
    const holeDiameter = holeRadius * 2;
    $ad2bcec7a0192558$var$p.innerHTML = `${numberOfHoles} trous<br/>\u{2300} ${holeDiameter} mm<br/>${Math.round(100 * (numberOfHoles * Math.PI * holeRadius ** 2) / (Math.PI * ($ad2bcec7a0192558$var$dimensions / 2) ** 2))}% air`;
    circles.forEach((n, r)=>{
        const radius = r / (circles.length - 1) * ($ad2bcec7a0192558$var$dimensions / 2 * $ad2bcec7a0192558$var$mm - holeRadius * $ad2bcec7a0192558$var$mm);
        // ctx.fillStyle = `hsl(${Math.random() * 360}, 100%, 50%)`
        for(let i = 0; i < n; i++){
            let x = Math.sin(i / n * Math.PI * 2) * radius + $ad2bcec7a0192558$var$dimensions / 2 * $ad2bcec7a0192558$var$mm;
            let y = Math.cos(i / n * Math.PI * 2) * radius + $ad2bcec7a0192558$var$dimensions / 2 * $ad2bcec7a0192558$var$mm;
            $ad2bcec7a0192558$var$ctx.beginPath();
            $ad2bcec7a0192558$var$ctx.ellipse(x, y, holeRadius * $ad2bcec7a0192558$var$mm, holeRadius * $ad2bcec7a0192558$var$mm, 0, 0, Math.PI * 2);
            $ad2bcec7a0192558$var$ctx.fill();
        }
    });
}
function $ad2bcec7a0192558$var$generateHolesGrid(_side) {
    $ad2bcec7a0192558$var$ctx.clearRect(0, 0, $ad2bcec7a0192558$var$canvas.width, $ad2bcec7a0192558$var$canvas.height);
    const positions = [];
    for(let y = 0; y < _side; y++)for(let x = 0; x < _side; x++){
        const pos = {
            x: (x + 0.5) * $ad2bcec7a0192558$var$dimensions / _side,
            y: (y + 0.5) * $ad2bcec7a0192558$var$dimensions / _side
        };
        // const isInsideCircle = true
        const isInsideCircle = Math.sqrt((pos.x - $ad2bcec7a0192558$var$dimensions / 2) ** 2 + (pos.y - $ad2bcec7a0192558$var$dimensions / 2) ** 2) < $ad2bcec7a0192558$var$dimensions / 2;
        // const isInsideCircle = (pos.x - (dimensions / 2)) ** 2 + (pos.y - (dimensions / 2)) ** 2 < dimensions * mm
        if (isInsideCircle) positions.push(pos);
    }
    const holesTotalArea = Math.PI * Math.pow($ad2bcec7a0192558$var$dimensions / 2, 2) * 0.25 // 25% air
    ;
    const numberOfHoles = positions.length;
    const holeArea = holesTotalArea / numberOfHoles;
    const holeRadius = Math.round(Math.sqrt(holeArea / Math.PI) * 4) / 4;
    const holeDiameter = holeRadius * 2;
    $ad2bcec7a0192558$var$p.innerHTML = `${numberOfHoles} trous<br/>\u{2300} ${holeDiameter} mm<br/>${Math.round(100 * (numberOfHoles * Math.PI * holeRadius ** 2) / (Math.PI * ($ad2bcec7a0192558$var$dimensions / 2) ** 2))}% air`;
    positions.forEach(({ x: x, y: y })=>{
        $ad2bcec7a0192558$var$ctx.beginPath();
        $ad2bcec7a0192558$var$ctx.ellipse(x * $ad2bcec7a0192558$var$mm, y * $ad2bcec7a0192558$var$mm, holeRadius * $ad2bcec7a0192558$var$mm, holeRadius * $ad2bcec7a0192558$var$mm, 0, 0, Math.PI * 2);
        $ad2bcec7a0192558$var$ctx.fill();
    });
}
function $ad2bcec7a0192558$var$generate() {
    if (Math.random() > 0.5) {
        const rows = Math.floor(Math.random() * 6 + 6);
        const base = Math.floor(Math.random() * 6 + 4);
        $ad2bcec7a0192558$var$generateHolesInCircle(rows, base);
    } else {
        const side = Math.floor(Math.random() * 20 + 5);
        $ad2bcec7a0192558$var$generateHolesGrid(side);
    }
}
$ad2bcec7a0192558$var$generate();


//# sourceMappingURL=index.0c1e4c6c.js.map
